// extracted by mini-css-extract-plugin
export default {"userForm":"Users_userForm__k1H6W","userForm_item":"Users_userForm_item__tVcpj"};